import React,{useState} from 'react'
import '../Launch/Launch.css'
import Icard from '../Icard/Icard';
const Launch = () => {
    const [isIcardOpen, setIsIcardOpen] = useState(false);
    
        const openIcard = () => {
            setIsIcardOpen(true);
          };
        
          const closeIcard = () => {
            setIsIcardOpen(false);
          };
  return (
    <>
     <div className="div-card-l">
     {isIcardOpen && <Icard onClose={closeIcard} />}
  <h2 className="div-card-title1-l">PAN OASIS</h2>
  <p className="div-card-title-l">SECTOR 70</p>
  <p className="div-card-location-l">Central Noida</p>
 
  <p className="div-card-sizes-l">2100+ & 2400+ for 3 BHK + Servant</p>
  <div className="div-card-pricing-l">
  
    <p className="launch-price-l">Expected price: ₹13,500–14,000 per sq ft + Other Charges</p>
  </div>
  <div className="div-card-eoi-l">
    
    <p className="eoi-text-l">First Come First Serve Basis and limited offer exclusivity</p>
  </div>
  <div className="div-card-limited-offer-l">
    
    <p className="limited-offer-text-l">Limited offer only for chosen one</p>
  </div>
  <div className="div-card-context-l">
   
    <p className="context-text-l">PRE-LAUNCH OF THE YEAR in CENTRAL NOIDA</p>
    <p className="context-subtext-l">Ultra Luxury residential society in the heart of Noida</p>
  </div>
  <button className="div-card-enquiry-l" onClick={openIcard}>Enquire Now</button>
</div>
    </>
  )
}

export default Launch